import React from "react";

import img from "./asset/pictures/svg_ML.svg";
import {
  MenuHeader,
  MenuItems,
  MenuItemsTitle,
  HeaderBorderTopLef,
  HeaderBorderTopRight,
  HeaderBorderBottomLeft,
  HeaderBorderBottomRight,
  HeaderTitle,
  HeaderLogo,
  HeaderList,
  HeaderListItem,
} from "./StyledComponents/Header.style";

const Header = () => {
  return (
    <>
      <MenuHeader>
        <HeaderTitle>Monia LAOUFI</HeaderTitle>
        <HeaderBorderTopLef />
        <HeaderBorderTopRight />
        <HeaderBorderBottomLeft />
        <HeaderBorderBottomRight />
        <HeaderLogo src={img} alt="logo Monia Laoufi" />
        <HeaderList>
          <HeaderListItem>
            <MenuItems
              href="https://github.com/Monia-L/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MenuItemsTitle>GitHub</MenuItemsTitle>
            </MenuItems>
          </HeaderListItem>

          <HeaderListItem>
            <MenuItems
              href="https://www.linkedin.com/in/monia-laoufi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MenuItemsTitle>Linkedin</MenuItemsTitle>
            </MenuItems>
          </HeaderListItem>

          <HeaderListItem>
            <MenuItems
              href="https://www.canva.com/design/DAEbBX-sUYk/Gcz7WDaxlbnLXEYMFpmUdw/view?utm_campaign=designshare&utm_source=sharebutton"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MenuItemsTitle>CV</MenuItemsTitle>
            </MenuItems>
          </HeaderListItem>
        </HeaderList>
      </MenuHeader>
    </>
  );
};
export default Header;
